import { createClient } from '@/lib/supabase/client';

export type ActivityAction =
  | 'add_game' | 'edit_game' | 'delete_game' | 'hide_game' | 'mark_game_sold'
  | 'change_user_role'| 'change_booking_status' | 'change_trade_in_status' |'edit_homepage_content'| 'update_site_settings' | 'mark_item_sold' |'add_mission' | 'edit_mission' | 'delete_mission'
  | 'add_event' | 'edit_event' | 'delete_event'
  | 'add_store_item' | 'edit_store_item' | 'delete_store_item'
  | 'upload_media' | 'delete_media'
  | 'redeem_reward' | 'update_passport';

interface LogActivityParams {
  action: ActivityAction;
  entityType?: string;
  entityId?: string;
  details?: Record<string, unknown>;
  actorEmail?: string;
}

export async function logActivity({
  action,
  entityType,
  entityId,
  details,
  actorEmail,
}: LogActivityParams): Promise<void> {
  try {
    const supabase = createClient();
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('admin_activity_log').insert({
      actor_id: user.id,
      actor_email: actorEmail || user.email,
      action,
      entity_type: entityType,
      entity_id: entityId ? String(entityId) : null,
      details: details || null,
    });
  } catch (err) {
    console.error('Activity log failed:', err);
  }
}
